import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect, useHistory } from 'react-router-dom'
import config from '../../config'
import { loginUser } from '../../ducks/auth'
import routes from '../../routes'
import { ForgetPassword } from './ForgetPassword'
import { LoginPageStyle } from './styled'
import { fixedAssets } from 'src/containers/PreCache'

export const LoginPage = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const { isFetching, isAuthenticated } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const history = useHistory()

  const handleLogin = (e) => {
    e.preventDefault()
    loginUser(dispatch, history, {
      email,
      password,
    })
  }
  const onPasswordInput = (e) => {
    setPassword(e.target.value)
  }

  const onEmailInput = (e) => {
    setEmail(e.target.value.toLowerCase())
  }

  useEffect(() => {
    document.title = `${config.eventName} | Login`
  }, [])

  if (isAuthenticated) {
    return <Redirect to={routes.lobby} />
  } else {
    return (
      <LoginPageStyle>
        <>
          <video 
            id="myVideo" 
            preload='auto'
            autoPlay 
          >
            <source src="https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/space-vid.mp4" type="video/mp4" />
          </video>
          <img width="100%" src={fixedAssets.kvTitleM} alt="event-banner" className="titleImage d-md-none d-block mx-auto" />
          <img width="100%" src={fixedAssets.kvTitle} alt="event-banner" className="titleImage d-none d-md-block mx-auto" />
          <img src={fixedAssets.growthBright} alt="event-visual" id="growth" className="visual mobile-hide" />
          <img src={fixedAssets.cognitionBright} alt="event-visual" id="cognition" className="visual mobile-hide" />
          <img src={fixedAssets.comfortBright} alt="event-visual" id="comfort" className="visual mobile-hide" />
          <img src={fixedAssets.rock} alt="event-visual" id="spacerock" className="visual mobile-hide" />
            
          <form id="formContainer" onSubmit={handleLogin}>
            <img src={fixedAssets.formBg} className="w-100" alt="login-form" />

            <div className='flexBox'>
              <div id="inputContainer">
                <>
                  <label>Email</label>
                  <input type="email" placeholder="Email Address" value={email} onChange={onEmailInput} />
                </>
                <>
                  <label>Password</label>
                  <input type="password" value={password} placeholder="Password" onChange={onPasswordInput} />
                </>
                <ForgetPassword />
                <div className="btn login-btn" onClick={handleLogin} style={{ background: isFetching ? 'lightgray' : '#FA7F25' }}>
                  <input disabled={!(email.length && password.length) || isFetching} type="submit" value={isFetching ? 'Submitting...' : 'Enter Conference'} />
                </div>
              </div>
            </div>
          </form>
        </>
      </LoginPageStyle>
    )
  }
}
